import get from 'lodash.get';
import { css } from 'styled-components';

const getFromTheme = (props) => (spec) => {
    const { theme: { olist: { [spec]: matchedSpec }, }, } = props;
    return matchedSpec;
};
const getSpacing = (props) => getFromTheme(props)('spacing');
const getBorderRadius = (props) => getFromTheme(props)('borderRadius');
const getColor = (props) => getFromTheme(props)('color');
const getFontFamily = (props) => getFromTheme(props)('fontFamily');
const getFontSize = (props) => getFromTheme(props)('fontSize');
const getFontWeight = (props) => getFromTheme(props)('fontWeight');
const getLetterSpacing = (props) => getFromTheme(props)('letterSpacing');
const getLineHeight = (props) => getFromTheme(props)('lineHeight');
const getOpacity = (props) => getFromTheme(props)('opacity');
const getShadow = (props) => getFromTheme(props)('shadow');
const generator = ({ props: componentProps, prop, cssProperty, getter = () => ({}), transform = (value) => value, }) => {
    const themeProp = getter(componentProps);
    // If prop is an array, ex: ['border', 'b'], we run the generator for each one
    if (Array.isArray(prop)) {
        return prop
            .map((p) => generator({
            props: componentProps,
            prop: p,
            cssProperty,
            getter,
            transform,
        }))
            .flat();
    }
    // Getting the desired prop from your component props
    const propFromComponent = componentProps[prop];
    // Getting the value from the theme
    const value = get(themeProp, propFromComponent, propFromComponent);
    const transformedValue = transform(value);
    // If the css is an array, like ['marginLeft', 'marginRight'], we produce
    // an object mapping all of values to its keys
    if (Array.isArray(cssProperty)) {
        const computedCSS = cssProperty.reduce((acc, property) => Object.assign(acc, { [property]: transformedValue }), {});
        return css(computedCSS);
    }
    return css({ [cssProperty]: transformedValue });
};
const compose = (...functions) => (args) => functions
    .map((fn) => fn(args))
    .flat()
    .filter(Boolean);

export { compose, generator, getBorderRadius, getColor, getFontFamily, getFontSize, getFontWeight, getFromTheme, getLetterSpacing, getLineHeight, getOpacity, getShadow, getSpacing };
